// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio--FZasu"};